import { ResponseGenerator } from 'common/type';
import { clearData } from 'modules/cargo-trace-search/slice';
import { cleanData } from 'modules/ship-movement-search/slice';
import { call, put, takeLatest } from 'redux-saga/effects';

import { loginAPI, changePasswordAPI, authorityApi } from './api';
import {
  login,
  loginSucceeded,
  loginError,
  changePassword,
  changePasswordSucceeded,
  changePasswordError,
  getAuthority,
  getAuthoritySuccess,
} from './slice';

function* loginSideEffect({ payload }: any) {
  const { data, callBack } = payload;
  try {
    const response: ResponseGenerator = yield call(loginAPI, data);
    yield put(
      loginSucceeded({
        token: response?.data?.token.accessToken,
        user: response?.data?.user,
      })
    );
    callBack && callBack();
    yield put(clearData());
    yield put(cleanData());
    yield put(getAuthority());
  } catch (error) {
    yield put(loginError(error));
    callBack && callBack();
  }
}

function* changePasswordSideEffect({ payload }: any) {
  const { data, onResponse, callback } = payload;
  try {
    const response: ResponseGenerator = yield call(changePasswordAPI, data);
    yield put(changePasswordSucceeded(response));
    if (response.meta.code === 0) {
      yield call(onResponse, true);
      callback && callback();
    } else {
      callback && callback();
    }
  } catch (error) {
    yield put(changePasswordError(error));
    callback && callback();
  }
}

function* getAuthoritySaga() {
  try {
    const response: ResponseGenerator = yield call(authorityApi);
    yield put(getAuthoritySuccess(response));
  } catch (error) {
    console.log(error);
  }
}

function* watchAuth() {
  yield takeLatest(login.type, loginSideEffect);
  yield takeLatest(changePassword.type, changePasswordSideEffect);
  yield takeLatest(getAuthority, getAuthoritySaga);
}

export default watchAuth;
